<template lang="pug">
// To manually test:
// Indent the v-snackbar and uncomment the following and the import of storeNotificationSnackbarManualTester
//div
//    h1 frontend\src\common\AppNotificationSnackbar.vue
//    storeNotificationSnackbarManualTester

v-snackbar(v-model='show' :timeout='timeout' :color='color') {{ text }}
    template(v-slot:actions v-if='timeout === KEEP_OPEN_INDEFINITELY')
        v-btn(dark text @click='show = false')
            | Close
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useNotificationStore } from '@/store/storeNotificationSnackbar';
// import storeNotificationSnackbarManualTester from '@/store/storeNotificationSnackbarManualTester.vue';

const KEEP_OPEN_INDEFINITELY = -1;

const show = ref(false);
const success = ref(true);
const timeout = ref(KEEP_OPEN_INDEFINITELY);
const text = ref('');

// ES Lint doesn't detect the usage in the pug template
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const color = computed(() => {
    if (success.value) {
        return 'green';
    } else {
        return 'red';
    }
});

const notificationStore = useNotificationStore();

watch(
    () => notificationStore.notificationNumber,
    () => {
        if (notificationStore.notificationInfo !== null) {
            if (notificationStore.isSuccess) {
                showSuccess(notificationStore.asString);
            } else if (notificationStore.isError) {
                showFailure(notificationStore.asString);
            }
        }
    },
);

const showSuccess = (message: string) => {
    text.value = message;
    success.value = true;
    timeout.value = 3000;
    show.value = true;
};

const showFailure = (message: string) => {
    text.value = message;
    success.value = false;
    timeout.value = KEEP_OPEN_INDEFINITELY;
    show.value = true;
};
</script>
